import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import TutorSidebar from "../TutorSidebar/TutorSidebar";
import TutorFooter from "../TutorFooter/TutorFooter";
import TutorHeader from "../TutorHeader/TutorHeader";
import { fetchChatrooms } from "./fetchChatroom"; // Update the path to your fetch logic
import { auth } from "../../firbase"; // Firebase auth to get the current user
import { jwtDecode } from "jwt-decode";
import Beatloader from "../../../Common/BeatLoader";
import { useDispatch, useSelector } from "react-redux";
import { getChatroomList } from "../../../Redux/action/MasterAction";
const TutorMessage = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        const authToken = localStorage.getItem('tutor-token')
        dispatch(getChatroomList(authToken))
    }, []);

    const {
        loadingChatroomListApi,
        ChatroomListApiData,
        ChatroomListApiError,

    } = useSelector(state => state?.MasterReducer);




    return (
        <div>
            <section className="after-header">
                {/* Breadcrumb */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item ps-5" aria-current="page">
                            <Link to="#" onClick={() => window.history.back()}>
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Message
                        </li>
                    </ol>
                </nav>

                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            {loadingChatroomListApi ?
                                <Beatloader />
                                :
                                <main className="px-3 py-4">
                                    <h4 className="mb-3">Message List</h4>
                                    {ChatroomListApiData?.length > 0 ?
                                        <div className="table-responsive">
                                            <table className="table table-striped" style={{ backgroundColor: "aliceblue" }}>
                                                <thead>
                                                    <tr>
                                                        <th scope="col">S.No.</th>
                                                        <th scope="col">Name</th>
                                                        <th scope="col">Last Message</th>
                                                        <th scope="col">Chat</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {ChatroomListApiData?.map((chatroom, index) => (
                                                        <tr key={chatroom.id}>
                                                            <th scope="row">{index + 1}</th>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    {/* <img
                                                                src={chatroom.avatar || "/assets/img/user/default-avatar.jpg"}
                                                                alt="User Avatar"
                                                                className="img-fluid rounded-circle"
                                                                style={{ height: 40, width: 40 }}
                                                            /> */}
                                                                    <div className="ms-3">
                                                                        <h6 className="mb-0">{chatroom.otherParticipant?.name || "Unknown User"}</h6>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <p className="mb-0">{chatroom.lastMessage || "No messages yet"}</p>
                                                            </td>
                                                            <td>
                                                                <Link to={`/tutor/chat/${btoa(chatroom.id)}`} className="nav-link">
                                                                    <i className="fas fa-comment-dots text-primary" />
                                                                </Link>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                        :
                                        <div className='row '>
                                            <div className='col-md-12 d-flex justify-content-center align-items-center flex-column' style={{ opacity: '0.5' }}>
                                                <img width={200} src="/assets/img/user/talk-show.png" alt="" srcset="" />
                                                <h2>Start Conversation</h2>
                                            </div>
                                            <div className='col-md-12'>

                                            </div>
                                        </div>
                                    }
                                </main>}
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TutorMessage;
